import { DateTime } from "luxon";

import { LocalStorageFilterValueTypes } from "~components/Organisms/IndexFilters/types";

import { FilterValues, RequestIndexPage } from "./types";

/** The backend only indexes a 30 day window, so the reel cannot page past it. */
const RANGE_IN_DAYS = 30;

/** Luxon numbers weekdays from Monday, so Saturday and Sunday are 6 and 7. */
const FIRST_WEEKEND_DAY = 6;

/**
 * The ascending weekdays the reel can scroll through: today forwards on the
 * active page, up to yesterday on the past page. The window stays 30 calendar
 * days, so dropping weekends shortens the reel rather than reaching further.
 */
export function buildDates(page: RequestIndexPage, now: DateTime): Array<DateTime> {
  const today = now.startOf("day");
  // Active needs the extra day to cover today through the end of the window.
  const [start, duration]: [DateTime, number] =
    page === "active"
      ? [today, RANGE_IN_DAYS + 1]
      : [today.minus({ days: RANGE_IN_DAYS }), RANGE_IN_DAYS];

  return Array.from({ length: duration }, (_, i) => start.plus({ days: i })).filter(
    (date) => date.weekday < FIRST_WEEKEND_DAY,
  );
}

/**
 * Translates the selected day into the filter shape `useRequests` already
 * understands, as a single day custom range.
 */
export function toRequestFilters(filters: FilterValues): LocalStorageFilterValueTypes {
  const { date, statuses, schools } = filters;

  const day = date ? DateTime.fromISO(date) : undefined;

  if (!day?.isValid) {
    return { statuses, schools, dateOption: undefined, customDates: undefined };
  }

  return {
    statuses,
    schools,
    dateOption: "custom",
    customDates: {
      start: day.startOf("day").toISO() ?? undefined,
      end: day.endOf("day").toISO() ?? undefined,
    },
  };
}
